import React from "react";
import Dialog from "./dialog/Dialog";
import "../assets/setupLn.scss";
import SetUpLnAddressSuccess from "./SetUpLnAddressSuccess";

function LnAddressSuccessModal({
  isOpenModal,
  setIsOpenModal,
  handleClose,
  userName,
  customClass,
  directionToOpen,
  isFromBrowser,
}) {
  return (
    <SetUpLnAddressSuccess
      userName={userName}
      handleClose={handleClose}
      customClass={customClass}
      isFromBrowser={isFromBrowser}
    />
  );
}

export default LnAddressSuccessModal;
